import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HREF } from '@core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  router = inject(Router);

  goToBrandStore(brandId: string | number, queryParams: Record<string, string> = {}): void {
    this.router.navigate([HREF.BRANDSTORE, brandId], { queryParams: { brandId, ...queryParams } }); //addiing querry param for behavioral analytics tracking purposes
  }

  goToCategoryPage(categoryId: string | number, queryParams: Record<string, string> = {}): void {
    this.router.navigate([HREF.CATEGORY_PRODUCTS, categoryId], { queryParams: { categoryId, ...queryParams } }); //addiing querry param for behavioral analytics tracking purposes
  }

  goToProductPage(
    productId: string | number,
    brandId: string | number,
    queryParams: Record<string, string> = {},
  ): void {
    this.router.navigate([HREF.PRODUCTS, productId], { queryParams: { productId, brandId, ...queryParams } }); //addiing querry param for behavioral analytics tracking purposes
  }
  goToAppleCategoryPage(categoryId: string | number, queryParams: Record<string, string> = {}): void {
    const url = HREF.APPLE_CATEGORY + categoryId.toString();
    this.router.navigate([url], {
      queryParams: { categoryId, ...queryParams },
    });
  }
  parseLinkAndNavigate(link: string): void {
    const parsedUrl = this.router.parseUrl(link);
    const url = parsedUrl.root.children['primary']?.segments.map((segment) => segment.path).join('/');
    this.router.navigate([url], { queryParams: parsedUrl.queryParams });
  }
}
